import React from 'react';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import './ResetPassword.css';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
    },
});

let redirectLocation;

class ResetPasswordConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password1: '',
            password2: '',
            successChangeRequest: false,
            token: this.props.match.params.token,
            tokenIsValid: true
        };

        this.handleChangePassword1 = this.handleChangePassword1.bind(this);
        this.handleChangePassword2 = this.handleChangePassword2.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChangePassword1(event) {
        this.setState({
            password1: event.target.value
        });
    }

    handleChangePassword2(event) {
        this.setState({
            password2: event.target.value
        });
    }

    handleSubmit(event) {
        event.persist();

        fetch("/account-management/api/change-password/" + this.state.token, {
            method: 'put',
            body: JSON.stringify({password: this.state.password1}),
            headers: {'Content-Type': 'application/json'}
        })
            .then(
                (response) => {
                    if(200 === response.status) {
                        this.setState({successChangeRequest: true});
                        setInterval(this.redirect, 3000);
                    } else {
                        console.error(`Failed to change password: ${response.status}, ${response}`);
                    }
                },
                (error) => {
                    console.error(`Failed to change password.`, error);
                }
            )
    }

    redirect () {
        console.log('Redirect to' + redirectLocation);
        window.location.replace(redirectLocation);
    }

    componentWillMount() {
        fetch("/account-management/api/check-token/" + this.state.token)
            .then(response => response.json())
            .then(
                (response) => {
                    if(response && response.newLocation) {
                        redirectLocation = response.newLocation;
                        console.log(`Set redirect location: ${redirectLocation}`);
                    } else {
                        this.setState({ tokenIsValid: false });
                    }
                },
                (error) => {
                    console.error(`Failed to check token: ${this.state.token}`, error);
                }
            )

    }

    componentDidMount() {
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== this.state.password1) {
                return false;
            }
            return true;
        });
    }

    render() {
        const { classes } = this.props;

        return <ValidatorForm autoComplete="off" className={'reset-password-form'} onSubmit={this.handleSubmit}>
            <h3 className={'reset-password-label'}>Reset password confirmation</h3>
            <TextValidator
                id="password1"
                label="Password"
                value={this.state.password1}
                type="password"
                margin="normal"
                required={true}
                fullWidth={true}
                onChange={this.handleChangePassword1}
                validators={['required']}
                errorMessages={['this field is required']}
            />
            <TextValidator
                id="password2"
                label="Confirm Password"
                value={this.state.password2}
                type="password"
                margin="normal"
                required={true}
                fullWidth={true}
                onChange={this.handleChangePassword2}
                validators={['required', 'isPasswordMatch']}
                errorMessages={['this field is required']}
            />
            <Button variant="outlined" className={'reset-password-button'} type="submit">
                Save
            </Button>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.state.successChangeRequest}
                >
                <div style={getModalStyle()} className={classes.paper}>
                    <Typography variant="subtitle1" id="simple-modal-description">
                        The password has been successfully changed, redirecting to login page...
                    </Typography>
                    <CircularProgress className={classes.progress} />
                </div>
            </Modal>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={!this.state.tokenIsValid}
            >
                <div style={getModalStyle()} className={classes.paper}>
                    <Typography variant="subtitle1" id="simple-modal-description">
                        The provided token is not valid.
                    </Typography>
                </div>
            </Modal>

        </ValidatorForm>;
    }
}

ResetPasswordConfirmation.propTypes = {
    classes: PropTypes.object.isRequired,
};

const ResetPasswordConfirmationWrapped = withStyles(styles)(ResetPasswordConfirmation);

export default ResetPasswordConfirmationWrapped;
